var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tutorial-messages thinly-shadowed"},[_c('p',[_vm._v(_vm._s(_vm.$t(`tutorial.${_vm.step}`)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }